import React, {useEffect} from 'react'
import { BootstrapTable, TableHeaderColumn, ClearSearchButton } from 'react-bootstrap-table';
import HistoriquePretTableData from './HistoriquePretTableData'
import HistoriquePretTableSkeleton from './HistoriquePretTableSkeleton'
// import * as IconlyPack from 'react-iconly';

const HistoriquePretTable = (props) => {
    var [isPageLoading, setIsPageLoading] = React.useState(true);
    // eslint-disable-next-line
    var [historique, setHistorique] = React.useState(HistoriquePretTableData)

    useEffect(() => {
        setTimeout(() => {
            setIsPageLoading(false)
        }, 5000);
    }, [historique])

    var handleClearButtonClick = (onClick) => {
        console.log('This is my custom function for ClearSearchButton click event');
        onClick();
    }

    var createCustomClearButton = (onClick) => {
        return (
            <ClearSearchButton
                btnText='Effacer'
                btnContextual='btn-warning'
                className='my-custom-class'
                onClick={e => handleClearButtonClick(onClick)} />
        );
    }

    const options = {
        clearSearch: true,
        clearSearchBtn: createCustomClearButton,
        noDataText: 'Aucune donnée disponible'
    }

    // const actionFormatter = (cell, row) => {
    //     return(
    //         <div className="table-actions-btn-container">
    //             <NavLink to={`/admin/profil-client/${row.id}`} className="action-btn show-btn">
    //                 <IconlyPack.Show set="light" primaryColor="#C8C8C8" className="action-btn-icon action-show-icon"/>
    //             </NavLink>
    //             <button className="action-btn edit-btn">
    //                 <IconlyPack.Edit set="light" primaryColor="#C8C8C8" className="action-btn-icon action-edit-icon"/>
    //             </button>
    //         </div>
    //     )
    // }

    const currencyFormatter = (cell) => {
        // const num = 1234567890.1234;
        const formatConfig = {
          style: "currency",
          currency: "XOF",
          minimumFractionDigits: 0,
          currencyDisplay: "symbol",
          currencySign: "accounting",
        };
    
        // setup formatters
        const xofNumberFormatter = new Intl.NumberFormat("sn-SN", formatConfig);
        return xofNumberFormatter.format(cell);
    };
    



    return(
        <div className="child-table-container">
            <div className="table-body-container-activite my-5">

                <div className="row easypm-table-row">
                    <div className="col-md-12 easypm-table-col">
                        {isPageLoading &&
                            <HistoriquePretTableSkeleton />
                        }
                        {!isPageLoading &&
                            <div className="table-container-activite">
                                <BootstrapTable data={historique}
                                    hover={true} condensed={true}
                                    multiColumnSort={2} options={options}
                                    search={false} version='4'
                                    bordered={false}>
                                    <TableHeaderColumn
                                        thStyle={{ fontWeight: 600, fontSize: 16, color: 'var(--secondary-color)' }}
                                        tdStyle={{ fontWeight: 500, fontSize: 14, color: 'rgba(0, 0, 0, 0.7)' }}
                                        width="100" dataField='projet' isKey={true} >Projets</TableHeaderColumn>
                                    <TableHeaderColumn
                                        thStyle={{ fontWeight: 600, fontSize: 16, color: 'var(--secondary-color)' }}
                                        tdStyle={{ fontWeight: 500, fontSize: 14, color: 'rgba(0, 0, 0, 0.7)' }}
                                        width="100" dataField='score'>Score</TableHeaderColumn>
                                    <TableHeaderColumn
                                        thStyle={{ fontWeight: 600, fontSize: 16, color: 'var(--secondary-color)' }}
                                        tdStyle={{ fontWeight: 500, fontSize: 14, color: 'rgba(0, 0, 0, 0.7)' }}
                                        width="100" dataField='taux'>Taux</TableHeaderColumn>
                                    <TableHeaderColumn
                                        thStyle={{ fontWeight: 600, fontSize: 16, color: 'var(--secondary-color)' }}
                                        tdStyle={{ fontWeight: 500, fontSize: 14, color: 'rgba(0, 0, 0, 0.7)' }}
                                        width="100" dataField='preter' dataFormat={(cell) => currencyFormatter(cell)}>Prêtés</TableHeaderColumn>
                                    
                                    <TableHeaderColumn
                                        thStyle={{ fontWeight: 600, fontSize: 16, color: 'var(--secondary-color)' }}
                                        tdStyle={{ fontWeight: 500, fontSize: 14, color: 'rgba(0, 0, 0, 0.7)' }}
                                        width="100" dataField='percu' dataFormat={(cell) => currencyFormatter(cell)}>Perçus</TableHeaderColumn>
                                    <TableHeaderColumn 
                                        thStyle={{fontWeight: 600, fontSize: 16, color: 'var(--secondary-color)'}}
                                        tdStyle={{ fontWeight: 500, fontSize: 14, color: 'rgba(0, 0, 0, 0.7)'}} 
                                        width="100" dataField='provision'>Provisions</TableHeaderColumn>
                                    <TableHeaderColumn 
                                        thStyle={{fontWeight: 600, fontSize: 16, color: 'var(--secondary-color)'}}
                                        tdStyle={{ fontWeight: 500, fontSize: 14, color: 'rgba(0, 0, 0, 0.7)'}} 
                                        width="100" dataField='en_cours'>En cours</TableHeaderColumn>
                                </BootstrapTable>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HistoriquePretTable;